import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SelectContent from '../../redux/containers/navbar/SelectContent';
import MenuContent from '../../redux/containers/navbar/MenuContent';
//import CardAlert from './CardAlert';
import OptionsMenu from '../../redux/containers/navbar/OptionsMenu';

// Color palette que coincide con los KPI cards y la tabla
const COLORS = {
  primary: '#2196f3',
  success: '#4caf50',
  warning: '#ffc107',
  purple: '#673ab7',
  background: '#f7f9fc',
  lightBorder: '#e3f2fd',
  drawerBackground: '#ffffff'
};

const drawerWidth = 290;

const Drawer = styled(MuiDrawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
    backgroundColor: COLORS.drawerBackground,
    borderRight: `1px solid ${COLORS.lightBorder}`,
    boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.05), 0px 1px 10px 0px rgba(0,0,0,0.025)',
  },
}));

const UserProfileBox = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  gap: theme.spacing(1),
  alignItems: 'center',
  borderTop: `1px solid ${COLORS.lightBorder}`,
  backgroundColor: alpha(COLORS.primary, 0.03),
  transition: 'background-color 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: alpha(COLORS.primary, 0.05),
  }
}));

const ProfileAvatar = styled(Avatar)(({ theme }) => ({
  width: 36,
  height: 36,
  border: `2px solid ${alpha(COLORS.primary, 0.2)}`,
  backgroundColor: alpha(COLORS.primary, 0.1),
  color: COLORS.primary,
  fontWeight: 'bold',
  '&:hover': {
    transform: 'scale(1.05)',
    transition: 'transform 0.2s ease-in-out',
  }
}));

const UserName = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  lineHeight: '16px',
  color: '#424242',
}));

const UserEmail = styled(Typography)(({ theme }) => ({
  color: 'text.secondary',
  fontSize: '0.75rem',
}));

const SelectBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginTop: '60px',
  padding: theme.spacing(1.5),
  backgroundColor: alpha(COLORS.primary, 0.02),
}));

export default function SideMenu(props) {
  const { profile } = props;
  
  // Obtener iniciales del nombre para el avatar
  const getInitials = (name) => {
    if (!name) return '';
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };
  
  const userInitials = getInitials(profile.first_name + ' ' + profile.last_name);
  
  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
      }}>
      <SelectBox>
        <SelectContent />
      </SelectBox>
      <Divider sx={{ borderColor: COLORS.lightBorder }} />
      <Box sx={{ 
        backgroundColor: COLORS.background,
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'
      }}>
        <MenuContent tenant_id={profile.tenant_id} />
      </Box>
      {/*<Card}Alert />*/}
      <UserProfileBox
        direction="row">
        <ProfileAvatar alt={profile.first_name}>
          {userInitials}
        </ProfileAvatar>
        <Box sx={{ mr: 'auto' }}>
          <UserName variant="body2">
            {profile.first_name + ' ' + profile.last_name}
          </UserName>
          <UserEmail variant="caption">
            {profile.email}
          </UserEmail>
        </Box>
        <OptionsMenu />
      </UserProfileBox>
    </Drawer>
  );
}
